import * as React from "react";
import { Modal, ModalBody } from 'reactstrap';
import { logUI } from "../../api/andyliticsApi";
import PhoneNumber from "../common/inputv2/PhoneNumber";
import MiniSpinner from "../common/MiniSpinner";
import { connect } from "react-redux";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";

class UserMobileModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mobileNumber: "",
            isValid: false,
            formSubmitted: false,
            formErrors: false,
            showModal: true,
        };
    }

    incrementPopupCount() {
        const { loginEvent, incrementPopupCount, userSettings } = this.props;
        if (loginEvent) {
            const incrementCounter = {
                smsNumberPopupCount: userSettings && userSettings.smsNumberPopupCount ? userSettings.smsNumberPopupCount + 1 : 1,
                showModal: false
            }
            logUI("UI.UserMobileModal.IncrementPopupCount", new Date(), Tools.getURLPath(), incrementCounter);
            incrementPopupCount(incrementCounter);
        }
    }

    toggleModal = () => {
        this.setState({ ...this.state, showModal: !this.state.showModal });
        logUI("UI.UserMobileModal.ToggleModal", new Date(), Tools.getURLPath());
        this.incrementPopupCount();
    }

    handleSave = (e) => {
        e.preventDefault();
        if (this.state.isValid) {
            const { loginEvent, userSettings, updateMobileNumber } = this.props;
            const payload = { smsNumber: this.state.mobileNumber, sendSms: true };
            if (loginEvent) {
                payload.smsNumberPopupCount = userSettings && userSettings.smsNumberPopupCount ? userSettings.smsNumberPopupCount + 1 : 1;
            }
            logUI("UI.UserMobileModal.Btn.Save.Clicked", new Date(), Tools.getURLPath());
            updateMobileNumber(payload);
            this.setState({ ...this.state, formErrors: false, formSubmitted: true })
        } else {
            this.setState({ ...this.state, formErrors: true, formSubmitted: false })
        }
    }

    handleNotNow = () => {
        logUI("UI.UserMobileModal.Btn.NotNow.Clicked", new Date(), Tools.getURLPath());
        this.setState({ ...this.state, showModal: false });
        this.incrementPopupCount();
        this.props.showInfoForMobileNoTooltip();
    }

    handleOkay = () => {
        const { userSettings, hideModal } = this.props;
        const isFailure = userSettings && userSettings.error;
        logUI(`UI.UserMobileModal.${isFailure ? 'Failure' : 'Success'}.OKAY.Clicked`, new Date(), Tools.getURLPath());
        hideModal();
        this.setState({ ...this.state, showModal: false })
    }

    render() {

        const { userSettings } = this.props;
        const { formErrors } = this.state;
        const isWaiting = userSettings && userSettings.waiting;
        const isFailure = userSettings && userSettings.error;

        return (
            <div>
                <Modal className="add-update-mobile-modal border-success" isOpen={this.state.showModal} centered toggle={this.toggleModal} backdrop="static">
                    <ModalBody className="modal-body">
                        {
                            this.state.formSubmitted ?
                                isWaiting ? <MiniSpinner /> :
                                    <div className="row">
                                        <div className="col-12 add-update-mobile-modal__message">
                                            <div className="add-update-mobile-modal__message-icon"><span className={!isFailure ? "icon-list-check" : "icon-input-clear"} /></div>
                                            <h2 className={!isFailure ? "add-update-mobile-modal__message-header h3" : "add-update-mobile-modal__message-header-failure"}>{isFailure ? "Your mobile number could not be saved." : "Thanks, you're all set!"}</h2>
                                            {isFailure ? <div className="add-update-mobile-modal__subheading">Your mobile number <span className="message-mobile-number">{this.state.mobileNumber}</span> has not been saved. <br className="d-none d-sm-block" />You can add your mobile number in notification preferences anytime.</div> :
                                                <div className="add-update-mobile-modal__subheading">Your mobile number <span className="message-mobile-number">{this.state.mobileNumber}</span> has been saved. <br className="d-none d-sm-block" />Your can change your notification preferences anytime.</div>}
                                        </div>
                                        <div className="col-12">
                                            <div className="text-center okay-btn-container">
                                                <button className="btn btn-primary btn-action" type="submit" onClick={this.handleOkay}>OKAY</button>
                                            </div>
                                        </div>
                                    </div>
                                :
                                <div className="row">
                                    <div className="col-12">
                                        <div className="add-update-mobile-modal__icon">
                                            <span className="svg-notification" />
                                        </div>
                                        <h2 className="add-update-mobile-modal__heading h3">Introducing BSW Virtual Notifications</h2>
                                        <div className="add-update-mobile-modal__subheading">Receive a text when a patient enters the virtual room.</div>
                                        <form className={"row" + (formErrors ? " form-submitted" : "")} onSubmit={this.handleSave}>
                                            <div className="col-12 form-group">
                                                <PhoneNumber placeholder="Mobile Number" name="mobileNumber" ref="mobileNumber" autoComplete="off" showClearBtn required inputErrorMsg="Invalid mobile number"
                                                    value={this.state.mobileNumber} onChange={(e, isValid) => this.setState({ mobileNumber: e.target.value, isValid, formErrors: !isValid })} />
                                            </div>
                                            <div className="col-12 text-center">
                                                <button className="btn btn-primary btn-action" type="submit">SAVE</button>
                                            </div>
                                        </form>
                                        <div className="text-center">
                                            <button type="button" className="btn text-btn notnow-btn" onClick={this.handleNotNow}>NOT NOW</button>
                                        </div>
                                    </div>
                                </div>
                        }
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userSettings: state.sso.userSettings
    };
}


const mapDispatchToProps = (dispatch) => {
    return {
        incrementPopupCount: payload => dispatch({ type: types.USER_SETTINGS, event: 'IncrementPopupCount', payload, waiting: true }),
        updateMobileNumber: payload => dispatch({ type: types.USER_SETTINGS, event: 'UpdateMobileNumber', payload, waiting: true }),
        hideModal: () => dispatch({ type: types.USER_SETTINGS, event: 'hideModal', payload: { showModal: false } }),
        showInfoForMobileNoTooltip: () => dispatch({ type: types.SHOW_INFOFORUPDATEMOBILENO_TOOLTIP }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserMobileModal);